// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

type Props = {
  children: ?Node,
  isActive: boolean,
  className?: string,
  style?: *,
};

export function NavigationNarrowElementPanel({ children, isActive, className, style }: Props) {
  return (
    <div
      className={classnames(
        className ? className : 'bg-white fixed bottom-0 rtl:right-0 p-4 w-full',
        {
          'translate-x-0': isActive,
          'rtl:translate-x-100': !isActive,
        },
      )}
      style={style}
    >
      {children}
    </div>
  );
}
